import React, { useEffect, useRef, useState } from "react";
import * as Icons from "react-feather";
import Modal from "./Modal";
import { useCore } from "store/core";
import Loading from "./Loading";
export default function ReportPreviewModal(props) {
  
  const core=useCore();
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(null);
  useEffect(()=>{
    setLoading(true);
    setData(null);
    if(!props.id)
    return;
    core.dispatch(core.getProductViewCount(props.id,(res)=>{
      setData(res);
      setLoading(false);
    }));
  },[props.id]);
  return (
    <Modal show={props.show} size={'modal-sm'} title={props.title} handleClose={props.close}>
      {loading&&<Loading/>}
      {data &&
      <div className="p-5">
        <span>نمایش با اشتراک :</span>
        <span>
          {data.subscription_u}
        </span>
        <hr/>
        <span>(همراه اول) نمایش با اشتراک :</span>
        <span>
          {data.mci_subscription_u}
        </span>
        <hr/>
        <span>نمایش با بلیت :</span>
        <span>
          {data.ticket_u}
        </span>
        <hr/>
        <span>نمایش با خرید فیلم :</span>
        <span>
          {data.buyMovie_u}
        </span>
        <hr/>
        <span>نمایش رایگان :</span>
        <span>
          {data.free_u}
        </span>
        <hr/>
        <span>کل نمایش :</span>
        <span>
          {data.total_u}
        </span>
        <hr/>
      </div>
      }
    </Modal>
  );
}
